// Agregar la clase 'ocultarTextos' a la página específica
if (window.location.href.includes("gotas-oticas-proear-miracell-2")) {
    document.body.classList.add("ocultarTextos");
}